export const projectUrl = {
  weatherLive: "https://world-weather-now.netlify.app/",
  weatherGit: "https://github.com/ManuuMT/weather-now",
  guardianLive: "https://guardian-orcin.vercel.app/",
  guardianGit: "https://github.com/ManuuMT/GUARDIAN-PROJECT",
  netflixLive: "https://netflix-copycat.netlify.app/",
  netflixGit: "https://github.com/ManuuMT/fakeflix",
};

export const projectImages = {
  guardian: require("../../../../assets/img/projects/project-guardian.png"),
  guardianCover: require("../../../../assets/img/projects/project-guardian-cover.png"),
  weather: require("../../../../assets/img/projects/project-weather.png"),
  weatherCover: require("../../../../assets/img/projects/project-weather-cover.png"),
  netflix: require("../../../../assets/img/projects/project-netflix.png"),
  netflixCover: require("../../../../assets/img/projects/project-netflix-cover.png"),
  github: require("../../../../assets/img/social/github.png"),
};
